# Action types
export RESET                    = 'RESET'
export SET_NAME                 = 'SET_NAME'
export SET_STEPS                = 'SET_STEPS'
export SET_FIELD_DATA           = 'SET_FIELD_DATA'
export SET_GRAPH                = 'SET_GRAPH'
export SET_IS_HIDDEN            = 'SET_IS_HIDDEN'
export SET_TYPE_NODE            = 'SET_TYPE_NODE'
export SET_LABEL                = 'SET_LABEL'
export SET_CONFIRMATION_MESSAGE = 'SET_CONFIRMATION_MESSAGE'
